import { useCallback, useEffect, useRef } from 'react';

function useDuplicatedCallback(callback, dependencies = [], delay = 250) {
  const lastCallRef = useRef({ args: null, timestamp: 0 });
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  return useCallback(
    (...args) => {
      const now = Date.now();
      const lastCall = lastCallRef.current;

      if (
        now - lastCall.timestamp < delay &&
        JSON.stringify(args) === JSON.stringify(lastCall.args)
      ) {
        // Prevent duplicate call
        return;
      }

      // Update the last call reference
      lastCallRef.current = { args, timestamp: now };

      // Call the original callback
      callbackRef.current(...args);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [delay, ...dependencies]
  );
}

export default useDuplicatedCallback;